/**
 *
 * 动画脚本
 *
 * 功能点:动画脚本
 * 场景:方案演示
 * 版本 1.0
 *
 */
import Vue from "@/main";
import screenplayFn from "@/components/tables/program/screenplayFn.js";
import * as constructionSimulation from "@/components/tables/animation/constructionSimulation/map.js";

/**
 *
 * 时间轴为特殊操作所有需要存储一下 当前在时间轴里操作的对象 方便时间轴结束后还原
 *
 */

export let animationData = [];
let initAnimation, destroyedAnimation;

export function getAnimation(animation) {
  // 获取时间轴数据
  animationData = animation;
}

export function getInitAnimation(fn, fn2) {
  // 初始化动画时间轴的方法
  initAnimation = fn;
  destroyedAnimation = fn2;
}
/**
 *
 * 初始化动画
 * 施工模拟
 *
 */
export function start(property, id, fn, ...list) {
  console.log(property, id, fn, initAnimation, ...list);
  if (property) {
    let animation, animationItem;
    animationItem = animationData.find((e) => e.id == id);
    animation = {
      groups: [
        {
          content: "施工模拟",
          id: "constructionSimulation",
        },
      ],
      animationData: [],
      initCustomDate: "",
      maxTime: "",
      programmeSimulationShow: false,
      loading: false,
    };
    animation.initCustomDate = animationItem.startTime;
    animation.maxTime = animationItem.endTime;
    animationItem.children.forEach((item) => {
      let end = item.endTime;
      animation.animationData.push({
        content: `${animationItem.name}-${item.name}`,
        group: "constructionSimulation",
        id: item.id,
        start: item.startTime,
        end,
        screenplay: [
          {
            screenplayType: "special", //复杂操作
            type: "animation", //动画操作
            executionProperty: "componentDyeing", //动画操作 施工模拟方法
            screenplayId: item.id,
            property: {
              id: item.id,
              type: item.isShow ? "show" : "hide", // 是隐藏还是显示操作
              component:
                typeof item.units == "string"
                  ? JSON.parse(item.units)
                  : item.units, // 构件数组
              screenplayId: item.modelId,
            },
          },
        ],
      });
    });
    console.log(animation);

    initAnimation(animation);
  } else {
    init(false);
  }
}

/**
 *
 * 动画预处理
 * 施工模拟
 *
 */
export function componentDyeing(property) {
  // 此处还需要记录 当前模型
  screenplayFn.constructionSimulation.componentStaining(
    property,
    property.screenplayId
  );
}

/**
 *
 * 动画预处理
 * 移出时间块方法
 *
 */
export function removeTimeBlock(property, id, type) {
  switch (type) {
    case "componentDyeing":
      // 当移除的时间块是施工模拟时候
      constructionSimulation.reductionStaining(property, property.screenplayId);
      break;
  }
}
/**
 *
 * 动画 初始化
 *
 */
export function init(status = true) {
  // 施工模拟初始化
  console.log("施工模拟初始化");
  constructionSimulation.init();
  if (!status) destroyedAnimation();
}
